var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "aPhoneSVG",
    d: "M26.42 23.668c-.307-.268-3.38-2.941-4.142-3.562a2.07 2.07 0 0 0-2.54-.119c-.911.668-2.304 1.669-2.532 1.802a.255.255 0 0 1-.076-.001c-.538-.392-2.945-2.203-4.005-4.013-1.034-1.757-1.54-3.118-1.876-4.02a27.537 27.537 0 0 0-.211-.555.392.392 0 0 1 .092-.457c.277-.162 1.354-.804 1.956-1.348.917-.828.807-1.929.79-2.055-.06-.464-.599-4.564-.79-5.377-.24-1.018-1.383-1.674-3.395-1.948-1.401-.191-3.19 1.458-3.74 2.008-1.337 1.158-1.828 2.649-1.946 5.88-.122 3.367 1.98 7.444 4.271 11.348 2.426 4.136 7.953 7.82 10.692 8.538 2.747.722 5.028-.6 5.887-1.098l.065-.036c1.123-.646 1.88-2.702 2.006-3.175.248-.924-.18-1.554-.505-1.812zm-1.116 1.387c-.194.722-.849 1.947-1.23 2.166l-.068.04c-.693.403-2.536 1.47-4.61.925-2.131-.56-7.421-3.934-9.672-7.767-2.06-3.512-4.151-7.502-4.043-10.456.111-3.065.556-3.99 1.39-4.707a.78.78 0 0 0 .048-.044c.845-.847 1.984-1.602 2.343-1.552.38.052.692.115.949.183.757.199 1.014.431 1.042.498.146.62.599 3.973.759 5.194a.82.82 0 0 1-.254.634c-.454.41-1.405.988-1.733 1.177a.916.916 0 0 0-.086.057c-.431.324-1.122 1.243-.66 2.406.061.154.126.328.2.523.355.954.893 2.397 1.998 4.278 1.373 2.344 4.466 4.521 4.597 4.613.05.035.105.064.161.088.089.036.872.34 1.603-.08.41-.236 2.32-1.63 2.689-1.9.23-.151.424.007.488.06.743.602 3.894 3.345 4.11 3.533a.51.51 0 0 1-.02.13h-.001z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "bPhoneSVG",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#aPhoneSVG"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    className: "fillColor",
    xlinkHref: "#aPhoneSVG"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    mask: "url(#bPhoneSVG)",
    className: "fillColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h32v32H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.1c5d01f5.svg";
export { ForwardRef as ReactComponent };